import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchFavoris = createAsyncThunk(
  "favorites/fetchFavoris",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}user/favorites`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data; // Should be an array
    } catch (error) {
      // console.error("fetchFavoris API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const addToFavorites = createAsyncThunk(
  "favorites/addToFavorites",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return rejectWithValue({ message: "Token manquant" });
      }
      const apiUrl = `${process.env.REACT_APP_API_URL}etablissements/${id}/favorite`;
      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data; // Should be a single favorite object
    } catch (error) {
      // console.error("addToFavorites API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

const favoritesSlice = createSlice({
  name: "favorites",
  initialState: {
    favorites: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearFavorites: (state) => {
      state.favorites = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch Favoris
    builder.addCase(fetchFavoris.pending, (state) => {
      state.status = "loading";
      state.error = null;
    });
    builder.addCase(fetchFavoris.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.favorites = Array.isArray(action.payload) ? action.payload : [];
      
    });
    builder.addCase(fetchFavoris.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload || "Erreur inconnue";
    });

    // Add to Favorites
    builder.addCase(addToFavorites.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(addToFavorites.fulfilled, (state, action) => {
      state.status = "succeeded";
      const newFavorite = action.payload;
      if (
        newFavorite &&
        typeof newFavorite === "object" &&
        newFavorite?.etablissement?.id
      ) {
        if (newFavorite?.favorited) {
          state.favorites = [...state.favorites, newFavorite?.etablissement];
          // change state.results
        } else {
          state.favorites = state.favorites.filter(
            (el) => el.id !== newFavorite?.etablissement?.id
          );
        }
      } else {
        // console.warn("Invalid favorite data received:", newFavorite);
      }
    });
    builder.addCase(addToFavorites.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload || "Erreur inconnue";
    });
  },
});

export const selectFavorites = (state) => state.favorites.favorites;
export const { clearFavorites } = favoritesSlice.actions;
export default favoritesSlice.reducer;
